import { forwardRef } from 'react'
import { useObjectRef } from '@react-aria/utils'
import Styles from './ChatInput.module.scss'
import { ChatInputProps } from './Types'
import { ChatActions } from './ChatActions'

export const ChatInput = forwardRef<HTMLTextAreaElement, ChatInputProps>(
  ({ value, onChange, placeholder, isDisabled, onSubmit, fileId, threadId }, fRef) => {
    const isValidInput = value.trim().length >= 2

    const textareaRef = useObjectRef<HTMLTextAreaElement>(fRef)

    const onResize = () => {
      if (textareaRef.current) {
        textareaRef.current.style.height = ''
        const height = Math.min(200, textareaRef.current.scrollHeight)
        textareaRef.current.style.height = `${height}px`
      }
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.stopPropagation()
      }

      if (e.key === 'Enter' && !e.shiftKey && !isDisabled && isValidInput) {
        e.preventDefault()
        onSubmit()
      }
    }

    return (
      <div className={Styles.inputContainer}>
        <div className={Styles.chatInput}>
          <textarea
            className={Styles.textarea}
            ref={textareaRef}
            id="ask-blaze"
            data-testid="ask-blaze"
            onChange={(e) => {
              onChange(e.currentTarget.value)
              onResize()
            }}
            onKeyDown={handleKeyDown}
            value={value}
            name="ask-blaze"
            placeholder={placeholder || 'Ask Blaze anything'}
            aria-label="Ask Blaze anything"
          />
          <ChatActions
            onChange={onChange}
            isDisabled={!isValidInput || !!isDisabled}
            onSubmit={onSubmit}
            fileId={fileId}
            threadId={threadId}
          />
        </div>
      </div>
    )
  },
)
